import type { CSSProperties, ReactNode } from 'react'
import '../style/components/ContentHeader.css'

type ContentHeaderProps = {
  title: string
  filters?: string[]
  activeFilter?: string
  onFilterChange?: (value: string) => void
  actions?: ReactNode
}

function ContentHeader({ title, filters, activeFilter, onFilterChange, actions }: ContentHeaderProps) {
  const showActions = Boolean(filters?.length || actions)
  const activeIndex = filters?.length
    ? Math.max(0, filters.findIndex((label) => label === activeFilter))
    : 0
  return (
    <div className="content-header">
      <h1>{title}</h1>
      {showActions ? (
        <div className="content-header-actions">
          {actions}
          {filters?.length ? (
            <div
              className="filters"
              style={
                {
                  ['--active-index' as string]: activeIndex,
                  ['--filter-count' as string]: filters.length,
                } as CSSProperties
              }
            >
              {filters.map((label) => (
                <button
                  type="button"
                  key={label}
                  className={`filter ${activeFilter === label ? 'active' : ''}`}
                  onClick={() => onFilterChange?.(label)}
                >
                  {label}
                </button>
              ))}
            </div>
          ) : null}
        </div>
      ) : null}
    </div>
  )
}

export default ContentHeader
